import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Button, Header, Message } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { filterItemsWithAdjustments, getAdjustmentForItem, getItemsChangedCopy } from './CartAdjustments.utils';
import CartAdjustment from './components/CartAdjustment';
import { CartItemPropType } from '../../../../domains/checkout/CartSummary/CartSummary.propTypes';
import { getErrorMessage } from '../../../../utils/api';
import { getItemName, getItemPhoto } from '../../services/order-item';
import './CartAdjustments.css';
var defaultProps = {
  header: /*#__PURE__*/React.createElement(Header, {
    as: "h2"
  }, " Important changes to items in your cart")
};
export default function CartAdjustments(_ref) {
  var items = _ref.items,
    onRemoveItem = _ref.onRemoveItem,
    onComplete = _ref.onComplete,
    header = _ref.header;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  if (_isEmpty(items)) {
    return null;
  }
  var itemsWithAdjustments = filterItemsWithAdjustments(items);
  if (_isEmpty(itemsWithAdjustments)) {
    return null;
  }
  function handleOnComplete() {
    return _handleOnComplete.apply(this, arguments);
  }
  function _handleOnComplete() {
    _handleOnComplete = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var acceptedAdjustments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setLoading(true);
            acceptedAdjustments = itemsWithAdjustments.map(function (item) {
              var _getAdjustmentForItem = getAdjustmentForItem(item),
                objectId = _getAdjustmentForItem.object_id,
                field = _getAdjustmentForItem.field;
              return {
                line_item_uuid: objectId,
                type: field
              };
            });
            _context.next = 5;
            return onComplete(acceptedAdjustments);
          case 5:
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            setErrorMessage(getErrorMessage(_context.t0));
          case 10:
            _context.prev = 10;
            setLoading(false);
            return _context.finish(10);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7, 10, 13]]);
    }));
    return _handleOnComplete.apply(this, arguments);
  }
  function clearError() {
    setErrorMessage('');
  }
  var itemsChangedCopy = getItemsChangedCopy(itemsWithAdjustments);
  return /*#__PURE__*/React.createElement("div", {
    className: "cart-adjustments"
  }, !_isEmpty(header) && /*#__PURE__*/React.createElement("div", {
    className: "header-container"
  }, header), /*#__PURE__*/React.createElement("p", {
    className: "items-changed"
  }, itemsChangedCopy), /*#__PURE__*/React.createElement("div", {
    className: "items-container"
  }, itemsWithAdjustments.map(function (item) {
    var uuid = item.uuid,
      price = item.price;
    var photo = getItemPhoto(item);
    var name = getItemName(item, {
      includeQuantity: true
    });
    var adjustment = getAdjustmentForItem(item);
    return /*#__PURE__*/React.createElement(CartAdjustment, {
      key: uuid,
      name: name,
      photo: photo,
      price: price,
      adjustment: adjustment,
      onRemoveItem: onRemoveItem
    });
  })), !_isEmpty(errorMessage) && /*#__PURE__*/React.createElement(Message, {
    error: true,
    content: errorMessage,
    onDismiss: clearError
  }), /*#__PURE__*/React.createElement(Button, {
    className: "got-it-button",
    primary: true,
    disabled: loading,
    loading: loading,
    content: "Got it",
    onClick: handleOnComplete
  }));
}
CartAdjustments.defaultProps = defaultProps;